import { render } from "./Subsidiary.vue?vue&type=template&id=f532393a&scoped=true&ts=true"
import script from "./Subsidiary.vue?vue&type=script&lang=ts"
export * from "./Subsidiary.vue?vue&type=script&lang=ts"

import "./Subsidiary.vue?vue&type=style&index=0&id=f532393a&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f532393a"]])

export default __exports__